<template>
  <footer id="kgu-footer">

    <div class="container">

      <ul class="footer-nav nav">

        <li><a href="static/Lageplan2023.pdf" target="_blank">Lageplan</a></li>

        <li><router-link :to="'/impressum'">Impressum</router-link></li>

        <li><router-link :to="'/datenschutz'">Datenschutz</router-link></li>

      </ul>

    </div>

  </footer>
</template>

<script>
export default {
  name: 'KguFooter',
}
</script>
